module.exports = __webpack_public_path__ + "img/9.ccf6ff46.png";